/**
 * @file
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";


export function InitializeGFBStep2Page() {
    // --------------------------------------------------------------------------
    // initialize the validation engine
    // --------------------------------------------------------------------------
    var onSubmit = false;
    customValidationInit(onSubmit);
    aspControlValidationInit();

    $('[id$="txtForbearanceBeginDate"]').mask("99-99-9999");
    $('[id$="txtForbearanceEndDate"]').mask("99-99-9999");

    $('[id$="chkCoronoVirus"]').click(function () {
        var chkCorono = $(this).is(":checked");
        var rblTempHardshipReason = $("[id$='rblPTemporaryHardshipReason']");
        var txtOtherExplain = $("[id$='txtOtherExplain1']");

        // if checked then update radio button list to other and add corono reason to textbox
        if (chkCorono) {
            rblTempHardshipReason.find("input[value='3']").prop("checked", true);
            txtOtherExplain.val("Medical reason due to Coronavirus.");
        } else {
            // if unchecked then clear textbox and uncheck radio button other if text box contains "Coronavirus"
            var explainText = txtOtherExplain.val();
            if (explainText.indexOf("Coronavirus")) {
                txtOtherExplain.val("");
                rblTempHardshipReason.find("input[value='3']").prop("checked", false);
            }
        }

    });

    $('[id$="rblPTemporaryHardshipReason"]').change(function () {
        var rblTempHardshipReason = $("[id$='rblPTemporaryHardshipReason']"); 

        if (rblTempHardshipReason.find(":checked").val() != 3) {
            var txtOtherExplain = $("[id$='txtOtherExplain1']");
            var chkCoronoVirus = $("[id$='chkCoronoVirus']");

            txtOtherExplain.val("");
            chkCoronoVirus.prop("checked", false);

        }
    });

 };
